<app-help-page mainVideo="managing-metrics"
               [tutorials]="['metrics-in-adloop', 'metrics-dimensions-per-data-source']"
               [videos]="['managing-metrics']"></app-help-page>
